import React, {useState} from 'react';
import { Button, Divider, Layout, Text, Icon, IndexPath, Select,Spinner, SelectItem, Input, Toggle, ToggleProps, CheckBox , CheckBoxProps } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image,ImageProps, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
// import * as RootNavigation from '../../../root.navigation.js';
import cities from '../../city.js';
import ostan from '../../province.js';
import { showMessage, hideMessage } from "react-native-flash-message";
import trackerApi from '../../api/tracker';

const width = Number(Dimensions.get('window').width) < 700 ? Dimensions.get('window').width : 700;
const height = Dimensions.get('window').height;


// const PlusIcon = (props) => (
//   <Icon {...props} name='plus-square-outline' />
// );

const PersonIcon = (props) => (
  <Icon {...props} name='person' />
);

const NoIcon = (props) => (
  <Icon {...props} name='person' />
);

const PhoneIcon = (props) => (
  <Icon {...props} name='smartphone-outline' />
);

const TelIcon = (props) => (
  <Icon {...props} name='phone' />
);

const AddressIcon = (props) => (
  <Icon {...props} name='compass-outline' />
);
const SuccessIcon = (props) => (
  <Icon {...props} name='checkmark-circle-2' style={{width:16, height:16, marginHorizontal: 10}} fill='#ffffff'/>
);

const useToggleState = (initialState = false): ToggleProps => {
  const [checked, setChecked] = React.useState(initialState);

  const onCheckedChange = (isChecked): void => {
    setChecked(isChecked);
  };

  return { checked, onChange: onCheckedChange };
};

const useCheckboxState = (initialCheck = false): CheckBoxProps => {
  const [checked, setChecked] = React.useState(initialCheck);
  return { checked, onChange: setChecked };
};

export const ProductsScreen = () => {
  const [selectedIndex, setSelectedIndex] = useState(new IndexPath(0));
  const [ostanSelectedIndex, setOstanSelectedIndex] = useState(new IndexPath(0));
  const [firstname, setFirstname] = useState('')
  const [firstnameStatus, setFirstnameStatus] = useState()
  const [lastname, setLastname] = useState('')
  const [lastnameStatus, setLastnameStatus] = useState()
  const [phone, setPhone] = useState('')
  const [phoneStatus, setPhoneStatus] = useState()
  const [email, setEmail] = useState('')
  const [organization, setOrganization] = useState('')
  const [semat, setSemat] = useState('')
  const [organizationStatus, setOrganizationStatus] = useState()
  const [website, setWebsite] = useState('')
  const [address, setAddress] = useState('')
  const [btnDisabled, setBtnDisabled] = useState(false)


  const primaryToggleState = useToggleState();
  const secondaryToggleState = useToggleState();
  const monitorCheckboxState = useCheckboxState();
  const aioCheckboxState = useCheckboxState();
  const minipcCheckboxState = useCheckboxState();
  const etcCheckboxState = useCheckboxState();
  const eqpCheckboxState = useCheckboxState();


  const LoadingIndicator = (props: ImageProps): React.ReactElement => (
    <View style={[props.style, styles.indicator]}>
      <Spinner size='small' />
    </View>
  );
  const verifyInformation = async()=>{
    if(firstname.length ==0){
      setFirstnameStatus('danger')
      showMessage({
             message: `نام را وارد کنید.`,
             type: "danger",
             duration: 5000
           });
           setBtnDisabled(false)
    }
    else if(lastname.length == 0){
      setLastnameStatus('danger')
      showMessage({
             message: `نام خانوادگی را وارد کنید`,
             type: "danger",
             duration: 5000
           });
           setBtnDisabled(false)
    }
    else if(phone.length == 0){
      setLastnameStatus('danger')
      showMessage({
             message: `شماره تلفن را به درستی وارد نمایید.`,
             type: "danger",
             duration: 5000
           });
           setBtnDisabled(false)
    }
    else if(organization.length == 0){
      setOrganizationStatus('danger')
      showMessage({
             message: `نام شرکت / سازمان و یا فروشگاه خود را وارد کنید`,
             type: "danger",
             duration: 5000
           });
           setBtnDisabled(false)
    }
    else{
      setFirstnameStatus()
      setLastnameStatus()
      setOrganizationStatus()
      setPhoneStatus()

    setBtnDisabled(true)
    const response = await trackerApi.post('/addagent', {
      firstname,
      lastname,
      phone,
      email,
      web: website,
      organization,
      semat,
      province: ostan[ostanSelectedIndex.row],
      city: cities[ostanSelectedIndex.row][selectedIndex-1],
      work_address: address,
      account_type: secondaryToggleState.checked ? ' نمایندگی' : 'خریدار',
      person_type: primaryToggleState.checked ? 'حقوقی' : 'حقیقی',
      monitor: monitorCheckboxState.checked,
      aio: aioCheckboxState.checked,
      minipc: minipcCheckboxState.checked,
      hardware: eqpCheckboxState.checked,
      etc: etcCheckboxState.checked
    })
    if(response.data.status){
      showMessage({
             message: `اطلاعات شما با موفقیت ثبت شد.`,
             description: 'به زودی همکاران ما با شما در تماس خواهند بود.',
             type: "success",
             icon: SuccessIcon,
             duration: 10000
           });
           setBtnDisabled(false)
    }
    else {
      showMessage({
             message: `خطا در برقراری ارتباط`,
             type: "danger",
             duration: 5000
           });
           setBtnDisabled(false)
    }

}

  }

  return (

    <ScrollView>
      <Layout style={styles.container} level='2' >

        <View style={{justifyContent:'flex-start', alignItems:'center'}}>
        <Image source= {require('../../../assets/logo.png')} style={{width:200, height:200, marginVertical:5}} />

        <Text status='primary' category='h5' style={{marginVertical:5, textAlign:'center', lineHeight:25}}>ثبت اطلاعات مشتریان</Text>
        <Input
            style={{flex:1,margin:4, width: width-30}}
            label={evaProps => <Text {...evaProps}>نام</Text>}
            placeholder ='نام'
            value={firstname}
            accessoryLeft={PersonIcon}
            onChangeText = {newValue =>{ setFirstname(newValue)}}
            status = {firstnameStatus}
            key={1}
            />
            <Input
              style={{flex:1, margin:4, width: width-30}}
              label={evaProps => <Text {...evaProps} >نام خانوادگی</Text>}
              placeholder ='نام خانوادگی'
              value={lastname}
              accessoryLeft={PersonIcon}
              onChangeText = {newValue =>{ setLastname(newValue)}}
              status = {lastnameStatus}
              key={2}

              />

              <Input
             style={{flex:1, margin:8, width: width-30}}
             label={evaProps => <Text {...evaProps}>شماره همراه</Text>}
             placeholder ='شماره موبایل خود را وارد نمایید'
             value={phone}
             keyboardType = 'numeric'
             maxLength={11}
             accessoryLeft={PhoneIcon}
             onChangeText = {newValue =>setPhone(newValue)}
             status = { phoneStatus}
             key={4}
             />
             <View style={{alignItems:'flex-start', width:width-60, marginTop:10}}>
                      <Text appearance='hint' category='c2' style={{marginBottom:15}}>نوع درخواست خود را مشخص کنید(خریدار و یا درخواست نمایندگی)</Text>
                      <Toggle  {...secondaryToggleState}>
                        {evaProps => <Text {...evaProps}>{secondaryToggleState.checked ? 'درخواست اخذ نمایندگی' : 'خریدار'}</Text>}
                      </Toggle>
            </View>
             <View style={{alignItems:'flex-start', width:width-60, marginTop:10}}>
                      <Text appearance='hint' category='c2' style={{marginVertical:15}}>نوع شخصیت </Text>
                      <Toggle  {...primaryToggleState}>
                        {evaProps => <Text {...evaProps}>{primaryToggleState.checked ? 'حقوقی' : 'حقیقی'}</Text>}
                      </Toggle>
            </View>



           <View style={{alignItems:'flex-start', width:width-60, marginTop:30}}>
                      <Text appearance='hint' category='c2' style={{marginBottom:10}}>جهت همکاری به کدام یک از محصولات زیر علاقمند هستید؟ </Text>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        {...monitorCheckboxState}

                        >
                        <Text>
                          مانیتور
                        </Text>
                      </CheckBox>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        {...aioCheckboxState}
                        >
                        <Text>
                          رایانه یکپارچه All-in-One
                        </Text>
                      </CheckBox>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        {...minipcCheckboxState}
                        >
                        <Text>
                          mini PC
                        </Text>
                      </CheckBox>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        {...eqpCheckboxState}
                        >
                        <Text>
                          تامین قطعات کامپیوتری
                        </Text>
                      </CheckBox>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        {...etcCheckboxState}

                        >
                        <Text>
                          سایر
                        </Text>
                      </CheckBox>
                      </View>
        <Select
                           style={{flex:1, margin:8, width:width-60, marginTop:30}}
                           label={evaProps => <Text {...evaProps}>استان</Text>}
                           selectedIndex={ostanSelectedIndex}
                           value = {ostan[ostanSelectedIndex.row]}
                           onSelect={index => setOstanSelectedIndex(index)}>
                           {
                             ostan.map((data, index)=>{
                               return (
                                 <SelectItem title={data} key={index} />
                               )
                             })
                           }
                         </Select>

                         <Select
                           style={{flex:1, margin:8, width:width-60}}
                           label={evaProps => <Text {...evaProps}>شهرستان</Text>}
                           selectedIndex={selectedIndex}
                           value = {cities[ostanSelectedIndex.row][selectedIndex-1]}

                           onSelect={index => setSelectedIndex(index)}>
                           {
                             cities[ostanSelectedIndex.row].map((data)=>{
                               return (
                                 <SelectItem title={data} />
                               )
                             })
                           }

                         </Select>
                         <View style={{flexDirection:'row', marginTop:20}}>
                         <Input
                        style={{flex:1, margin:8, width: width/2-20}}
                        label={evaProps => <Text {...evaProps}>نام شرکت و یا کسب و کار</Text>}
                        placeholder ='نام کسب و کار'
                        value={organization}
                        maxLength={11}
                        accessoryLeft={AddressIcon}
                        onChangeText = {newValue =>setOrganization(newValue)}
                        status = { organizationStatus}
                        key={4}
                        />

                        <Input
                       style={{flex:1, margin:8, width: width/2-20}}
                       label={evaProps => <Text {...evaProps}>سمت خود را وارد فرمایید</Text>}
                       placeholder ='سمت'
                       value={semat}
                       maxLength={11}
                       accessoryLeft={AddressIcon}
                       onChangeText = {newValue =>setSemat(newValue)}
                       key={5}
                       />
                       </View>
                        <Input
                       style={{flex:1, margin:8, width: width-30, marginTop:20}}
                       label={evaProps => <Text {...evaProps}>در صورت داشتن سایت آدرس سایت خود را وارد نمایید</Text>}
                       placeholder ='آدرس سایت'
                       value={website}
                       maxLength={11}
                       accessoryLeft={AddressIcon}
                       onChangeText = {newValue =>setWebsite(newValue)}
                       key={4}
                       />
                       <Input
                      style={{flex:1, margin:8, width: width-30}}
                      label={evaProps => <Text {...evaProps}>در صورت تمایل آدرس محل کار خود را وارد نمایید</Text>}
                      placeholder ='آدرس'
                      value={address}
                      maxLength={11}
                      accessoryLeft={AddressIcon}
                      onChangeText = {newValue =>setAddress(newValue)}
                      multiline={true}
                      key={4}
                      />
          </View>
          <Button
            style={{width:width-60,borderRadius:10, marginBottom:100}}
            onPress = {verifyInformation}
            accessoryLeft={LoadingIndicator}
            disabled={btnDisabled}
            >تایید اطلاعات </Button>

      </Layout>
      </ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',
    paddingBottom:55,
  },
  indicator: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
// <Image source= {require('../../../assets/new_invoice.png')} style={{width:width*0.7, height:width*0.7, marginVertical:25}} />
